import { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";

function useTab(
  tabs: { id: string }[],
  name?: string,
  paramsToKeep?: string[],
  // defaultTab?: string,
) {
  const [searchParams, setSearchParams] = useSearchParams();
  const paramName = name ? `tab-${name}` : "tab";
  const activeTab = searchParams.get(paramName);

  const setActiveTab = (newTab: string): void => {
    //setSearchParams({ ...Object.fromEntries(searchParams.entries()), [paramName]: newTab });
    const allParams = { ...Object.fromEntries(searchParams.entries()) };
    const tabParams = Object.keys(allParams).reduce((acc, k) => {
      if ((paramsToKeep || []).find(v => v === k)) return { ...acc, [k]: allParams[k] };
      return acc;
    }, {})
    setSearchParams({ ...tabParams, [paramName]: newTab });
  }

  useEffect(() => {
    if (!tabs.some(v => v.id === activeTab)) {
      setActiveTab(tabs[0].id);
    }
  }, [activeTab])

  // useEffect(() => {
  //   if (!activeTab && defaultTab && tabs.some(v => v.id === defaultTab)) {
  //     setActiveTab(defaultTab);
  //   }
  // }, [defaultTab, activeTab])

  return { activeTab: activeTab ?? "", setActiveTab };
}

export default useTab;
